<template>
  <store-recherche-provider
    key="listeFactures"
    :name="constantes.storeName"
    :copy="factureStore">
    <liste-factures
      :nameStore="constantes.storeName"
      :referenceTable="constantes.referenceTable"/>
  </store-recherche-provider>
</template>

<script>
import factureStore from '@/store/modules/facture';
import listeFactures from '@/components/factures/liste/listeFactures';
import storeRechercheProvider from '@/components/general/store/storeRechercheProvider';
import { REFERENCE_TABLE_LISTE_FACTURE } from '@/configuration/general/referenceTableConf';

export default {
  name: 'ListeVenteFacture',
  components: {
    storeRechercheProvider,
    listeFactures,
  },
  data() {
    return {
      factureStore,
      constantes: {
        storeName: 'facture',
        referenceTable: REFERENCE_TABLE_LISTE_FACTURE,
      },
    };
  },
  mounted() {
    this.setInformationPage(this.$t('pageGescom.facture.liste'));
  },
};
</script>
